// Primary / Peach
export const peachLight = '#FFF5E9'
export const brandPrimary = peachLight
export const brandPrimaryLight = '#fffcf8'

// Secondary / Navy
export const navyMedium = '#001759'
export const navyDark = '#00103e'
export const brandSecondary = navyMedium
export const brandSecondaryDark = navyDark
export const brandBody = navyMedium

// Accents 

export const limeMedium = '#D2FF7E'
export const lilacMedium = '#E5B3FA'
export const blueMedium = '#D7FFFE'


// Monochrome
export const brandBlack = '#000000'
export const brandWhite = '#FFFFFF'
export const brandGreyDark = '#131415'